export default {
  buttonDisabledFill: 'rgb(41, 41, 41)',
  buttonDisabledText: 'rgb(117, 117, 117)',
}
